import React from "react";

export default class RouteErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
            this.setState({error: null});
        }
    }

    componentDidCatch(error, info) {
        console.error("Route render failed:", error, info);
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        const message = this.state.error?.message || "This page failed to load.";
        const isChunkError = /chunk|loading css chunk/i.test(message);

        return (
            <section style={{
                margin: 24,
                padding: 24,
                border: "1px solid #f0b8b8",
                borderRadius: 8,
                background: "#fff7f7",
                color: "#3f1f1f"
            }}>
                <h2 style={{margin: "0 0 8px", fontSize: 20}}>This section could not load</h2>
                <p style={{margin: "0 0 12px"}}>
                    {isChunkError
                        ? "A page file failed to download. Other pages are still available."
                        : "This page has an error. Other pages are still available."}
                </p>
                <pre style={{
                    margin: "0 0 16px",
                    padding: 12,
                    whiteSpace: "pre-wrap",
                    background: "#ffffff",
                    border: "1px solid #f3d0d0",
                    borderRadius: 6,
                    color: "#7f1d1d"
                }}>{message}</pre>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    style={{
                        border: 0,
                        borderRadius: 6,
                        padding: "10px 14px",
                        background: "#b91c1c",
                        color: "#ffffff",
                        cursor: "pointer"
                    }}
                >
                    Reload page
                </button>
            </section>
        );
    }
}
